export const GET_PROFILE="GET_PROFILE"

export const GET_PROFILE_REQUEST="GET_PROFILE_REQUEST"
export const GET_PROFILE_SUCCESS="GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAILUER="GET_PROFILE_FAILUER"